import { render, staticRenderFns } from "./chat-screen.vue?vue&type=template&id=542f21dc&scoped=true&"
import script from "./chat-screen.vue?vue&type=script&lang=js&"
export * from "./chat-screen.vue?vue&type=script&lang=js&"
import style0 from "./chat-screen.vue?vue&type=style&index=0&id=542f21dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542f21dc",
  null
  
)

export default component.exports